import { query } from "../../../erd-editor-schema/dist/query/index.js";
import { ColumnOption, StartRelationshipType } from "../../../constants/schema.js";
import { arrayHas } from "../../../utils/arrayHas.js";
import { bHas } from "../../../utils/bit.js";
//#region src/engine/modules/relationship/endFlags.ts
function selectEndColumns(collections, hasTable, { end }) {
	if (!hasTable(end.tableId)) return [];
	const table = query(collections).collection("tableEntities").selectById(end.tableId);
	if (!table) return [];
	const has = arrayHas(table.columnIds);
	return query(collections).collection("tableColumnEntities").selectByIds(end.columnIds).filter((column) => has(column.id));
}
function* endColumnsOf({ doc, collections }) {
	const hasTable = arrayHas(doc.tableIds);
	const hasRelationship = arrayHas(doc.relationshipIds);
	const relationships = query(collections).collection("relationshipEntities").selectAll();
	for (const relationship of relationships) yield [relationship, hasRelationship(relationship.id) ? selectEndColumns(collections, hasTable, relationship) : []];
}
function recalculateIdentification(state) {
	for (const [relationship, columns] of endColumnsOf(state)) {
		const value = columns.length !== 0 && columns.every((column) => bHas(column.options, ColumnOption.primaryKey));
		if (value !== relationship.identification) relationship.identification = value;
	}
}
function recalculateStartRelationshipType(state) {
	for (const [relationship, columns] of endColumnsOf(state)) {
		const value = columns.every((column) => bHas(column.options, ColumnOption.notNull)) ? StartRelationshipType.dash : StartRelationshipType.ring;
		if (value !== relationship.startRelationshipType) relationship.startRelationshipType = value;
	}
}
//#endregion
export { recalculateIdentification, recalculateStartRelationshipType };
